export enum ErrorImpact {
    /**
     * Should stop everything
     */
    CRITICAL = "critical",
    /**
     * Should at least log the error
     */
    NONE = "none",
}

export type ErrorWrapper = {
    error: Error;
    impact: ErrorImpact;
};

export type ErrorHandler = (err: ErrorWrapper) => void;

export type WithErrorHandling = {
    onError: ErrorHandler;
};
